import React from 'react';
import notFound from '../Images/404-error-page-not-found.jpg'
const NotFound = () => {
    return (
        <div>
            <img src={notFound} alt="" />
        </div>
    );
};

export default NotFound;